export class Course {
    airDate: Date | null = null;
    cityName: string | null = null;
    cityId: string | null = null;
    seasonName: string | null = null;
    seasonId: string | null = null;
    type: string | null = null;

    id() {
        if (this.cityName && this.type && this.seasonName) {
            return this.cityName.replace(/ /g, '_') + "__" + this.type.replace(/ /g, '_') + "__" + String(this.seasonName).replace(/ /g, "_");
        };
        return null;
    }
}
